module.exports = __webpack_public_path__ + "assets/img/service.2bb2b4c3.png";